import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-one-page',
    templateUrl: './one-page.component.html',
    styleUrls: ['./one-page.component.scss'],
    standalone: false
})
export class OnePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
